<template>
  <drag-dialog
    :visible.sync="visible"
    :title="activeId ? '编辑用户信息' : '新增用户信息'"
    width="1300px"
    height="750px"
    :before-close="() => $emit('update:visible', false)"
    @close="
      $dialogFormReset(
        'editForm',
        'orgTreeData',
        'politOptions',
        'mzOptions',
        'relationOptions',
        'xueli2Opitons',
        'xueweiOpitons'
      )
    "
  >
    <el-form v-loading="detailLoading" :model="editForm" ref="editForm" :rules="rules" label-width="100px">
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="基本信息" name="one">
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="16">
              <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                <el-col :span="12">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model.trim="editForm.name" placeholder="请输入" maxlength="20" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录账号" prop="loginName">
                    <el-input v-model.trim="editForm.loginName" placeholder="请输入" maxlength="20" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号码" prop="mobile">
                    <el-input
                      v-model="editForm.mobile"
                      placeholder="请输入"
                      onkeyup="value=value.replace(/[^\d-]/g,'')"
                      maxlength="20"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属部门" prop="deptId">
                    <el-cascader
                      v-model="editForm.deptId"
                      :props="orgProps"
                      :options="orgTreeData"
                      :show-all-levels="false"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="岗位" prop="t4">
                    <el-select v-model="editForm.t4" placeholder="请选择" clearable>
                      <el-option v-for="item in t4Options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="12">
                  <el-form-item label="状态" prop="deleted">
                    <el-switch
                      v-model="editForm.deleted"
                      :active-value="0"
                      :inactive-value="1"
                      active-text="在职"
                      inactive-text="离职"
                    ></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="入职时间" prop="joinTime">
                    <el-date-picker
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="日期选择"
                      v-model="editForm.joinTime"
                      style="width: 100%"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="角色" prop="roleIdArray">
                    <el-select v-model="editForm.roleIdArray" multiple placeholder="请选择" clearable>
                      <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号" prop="idcard">
                    <el-input v-model.trim="editForm.idcard" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="出生日期" prop="birthday">
                    <el-date-picker
                      v-model="editForm.birthday"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性别">
                    <el-select placeholder="请选择" v-model="editForm.sex" clearable style="width: 100%">
                      <el-option
                        v-for="(item, index) in sexOptions"
                        :key="index"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="政治面貌" prop="politstatus">
                    <el-select placeholder="请选择" v-model="editForm.politstatus" clearable style="width: 100%">
                      <el-option
                        v-for="(item, index) in politOptions"
                        :key="index"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="籍贯" prop="birthplace">
                    <el-input v-model.trim="editForm.birthplace" placeholder="请输入" maxlength="20" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="民族" prop="nation">
                    <el-select placeholder="请选择" v-model="editForm.nation" clearable style="width: 100%">
                      <el-option
                        v-for="(item, index) in mzOptions"
                        :key="index"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="8">
              <div>
                <el-form-item label="电子签名">
                  <ImageUpload v-model="fileListSignature" :limit="1" :paramsData="{ type: 'upt_signature' }" />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="劳动合同" name="two">
          <div style="margin-bottom: 10px">
            <el-button type="primary" @click="addRow(userTags6, 6)">新增</el-button>
          </div>

          <el-table
            :data="userTags6"
            height="calc(100% - 50px)"
            border
            stripe
            :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
            <el-table-column label="签订时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags6[$index]['tagstarttime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="到期时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags6[$index]['tagendtime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="上传附件" align="center">
              <template v-slot="{ $index }">
                <UploadButton
                  v-model="userTags6[$index]['fileList']"
                  :limit="1"
                  :fileType="['doc', 'docx', 'pdf']"
                  :paramsData="{ type: 'upt_usercontract' }"
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot="{ $index }">
                <el-link type="danger" @click="deleteRow($index, userTags6)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="家庭成员" name="three">
          <div style="margin-bottom: 10px">
            <el-button type="primary" @click="addRow(userTags0, 0)">新增</el-button>
          </div>

          <el-table
            :data="userTags0"
            height="calc(100% - 50px)"
            border
            stripe
            :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
            <el-table-column label="姓名" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags0[$index]['tagname']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="关系" align="center">
              <template v-slot="{ $index }">
                <el-select v-model="userTags0[$index]['tagtype']" placeholder="请选择">
                  <el-option v-for="(item, i) in relationOptions" :key="i" :label="item.name" :value="item.name" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="出生年月" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags0[$index]['tagtime']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="联系方式" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags0[$index]['taglevel']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot="{ $index }">
                <el-link type="danger" @click="deleteRow($index, userTags0)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="教育情况" name="four">
          <div style="margin-bottom: 10px">
            <el-button type="primary" @click="addRow(userTags1, 1)">新增</el-button>
          </div>
          <el-table
            :data="userTags1"
            height="calc(100% - 50px)"
            border
            stripe
            :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
            <el-table-column label="起始时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags1[$index]['tagstarttime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="截止时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags1[$index]['tagendtime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="就读院校" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags1[$index]['tagname']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="专业" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags1[$index]['taglevel']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="学历" align="center">
              <template v-slot="{ $index }">
                <el-cascader
                  v-model="userTags1[$index]['tagtype']"
                  :props="educateProps"
                  :options="xueli2Opitons"
                  :show-all-levels="false"
                  clearable
                ></el-cascader>
              </template>
            </el-table-column>
            <el-table-column label="学位" align="center">
              <template v-slot="{ $index }">
                <el-cascader
                  v-model="userTags1[$index]['tagremark']"
                  :props="educateProps"
                  :options="xueweiOpitons"
                  :show-all-levels="false"
                  clearable
                ></el-cascader>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot="{ $index }">
                <el-link type="danger" @click="deleteRow($index, userTags1)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="入职前工作经历" name="seven">
          <div style="margin-bottom: 10px">
            <el-button type="primary" @click="addRow(userTags4, 4)">新增</el-button>
          </div>
          <el-table
            :data="userTags4"
            height="calc(100% - 50px)"
            border
            stripe
            :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>

            <el-table-column label="工作单位" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags4[$index]['tagname']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="工作岗位" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags4[$index]['tagtype']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags4[$index]['tagstarttime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags4[$index]['tagendtime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags4[$index]['tagremark']"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot="{ $index }">
                <el-link type="danger" @click="deleteRow($index, userTags4)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="入职后工作经历" name="eight">
          <div style="margin-bottom: 10px">
            <el-button type="primary" @click="addRow(userTags5, 5)">新增</el-button>
          </div>
          <el-table
            :data="userTags5"
            height="calc(100% - 50px)"
            border
            stripe
            :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>

            <el-table-column label="工作单位" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags5[$index]['tagname']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="工作岗位" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags5[$index]['tagtype']" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags5[$index]['tagstarttime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center">
              <template v-slot="{ $index }">
                <el-date-picker
                  type="date"
                  clearable
                  :picker-options="optionPicker"
                  value-format="yyyy-MM-dd"
                  placeholder="日期选择"
                  v-model="userTags5[$index]['tagendtime']"
                  style="width: 100%"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
              <template v-slot="{ $index }">
                <el-input v-model.trim="userTags5[$index]['tagremark']"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot="{ $index }">
                <el-link type="danger" @click="deleteRow($index, userTags5)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane> -->
      </el-tabs>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import ImageUpload from '@/components/UploadArea/ImageUpload';
import UploadButton from '@/components/UploadArea/UploadButton';

import { getUserInfo, getOrgData, getRoleList, saveUser } from '@api/user';
import { getDictsByCode, getDictData } from '@api/system';

export default {
  components: { ImageUpload, UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      activeName: 'one',
      editForm: {
        deleted: 0,
        roleIdArray: []
      },
      fileListSignature: [],
      t4Options: [
        {
          value: '主任',
          label: '主任'
        },
        {
          value: '副主任',
          label: '副主任'
        }
      ],
      // 组织架构 部门
      orgTreeData: [],
      orgProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'text',
        children: 'nodes'
      },
      roleOptions: [],
      xueweiOpitons: [],
      sexOptions: [
        { id: 1, name: '男' },
        { id: 2, name: '女' }
      ],
      politOptions: [],
      mzOptions: [],
      xueli2Opitons: [],
      relationOptions: [],
      optionPicker: {
        disabledDate: time => {
          return time.getTime() > Date.now() - 8.64e5;
        }
      },
      educateProps: {
        emitPath: false,
        value: 'text',
        label: 'text',
        children: 'nodes'
      },
      userTags0: [], //家庭成员
      userTags1: [], //教育情况
      userTags4: [], //入职前工作经历
      userTags5: [], //入职后工作经历
      userTags6: [], //劳动合同
      rules: {
        name: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        loginName: [{ required: true, message: '请输入系统用户名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        deptId: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
        roleIdArray: [{ required: true, message: '请选择角色', trigger: 'change' }],
        idcard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        // t4: [{ required: true, message: '请选择岗位', trigger: 'change' }],
        joinTime: [{ required: true, message: '请选择入职时间', trigger: 'change' }],
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }]
      },
      detailLoading: false,
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getUserInfo();
      }
      if (val) {
        this.getOrgData();
        this.getRoleList();
        this.getDictsByCode('zzmm', 'politOptions');
        this.getDictsByCode('minzu', 'mzOptions');
        this.getDictsByCode('GX', 'relationOptions');
        this.getDictData('xueli2', 'xueli2Opitons');
        this.getDictData('xuewei', 'xueweiOpitons');
      }
    }
  },
  methods: {
    async getUserInfo() {
      this.detailLoading = true;
      const data = await getUserInfo(this.activeId);

      const roleIdArray = data?.roleIds ? data.roleIds.split(',') : [];
      this.editForm = { ...data, roleIdArray };
      this.fileListSignature = (data?.signature ? data.signature.split(',') : []).map(item => ({
        name: item,
        url: item
      }));

      this.userTags0 = data.userTags0 || [];
      this.userTags1 = data.userTags1 || [];
      this.userTags4 = data.userTags4 || [];
      this.userTags5 = data.userTags5 || [];
      this.userTags6 =
        data.userTags6?.map(item => {
          const fileList = item.tagpic
            ? [
                {
                  fileName: item.tagpic,
                  filePath: item.tagpic
                }
              ]
            : [];

          return {
            ...item,
            fileList
          };
        }) ?? [];

      this.detailLoading = false;
    },
    // 获取角色列表
    async getRoleList() {
      const { data } = await getRoleList({ pageNum: 1, pageSize: 9999 });

      this.roleOptions = data.list || [];
    },
    // 增加行
    addRow(rows, type) {
      let rowData = {
        type,
        tagname: '',
        tagtype: '',
        taglevel: '',
        tagtime: '',
        tagstarttime: '',
        tagendtime: '',
        tagremark: ''
      };
      if (type == 6) {
        rowData = { ...rowData, fileList: [] };
      }
      rows.push({ ...rowData });
    },
    // 删除行
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(`您确认要${this.editForm.id ? '修改' : '新增'}该用户信息？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(async () => {
              this.submitLoading = true;

              const signature = this.fileListSignature.map(item => item.url.replace(this.$imgUrl, '')).join(',');

              const roleIds = this.editForm.roleIdArray.join(',');

              // 劳动合同附件
              this.userTags6.map(item => {
                let filePath = '';
                if (item.fileList.length > 0) {
                  filePath = item.fileList[0].filePath.replace(this.$imgUrl, '');
                }
                item.tagpic = filePath;
              });

              const params = {
                ...this.editForm,
                roleIds,
                signature,
                userTags0: this.userTags0,
                userTags1: this.userTags1,
                userTags4: this.userTags4,
                userTags5: this.userTags5,
                userTags6: this.userTags6
              };

              try {
                await saveUser(params);
                this.$message.success(this.editForm.id ? '修改用户成功！' : '新增用户成功！');
                this.$emit('refresh');
                this.$emit('update:visible', false);
              } finally {
                this.submitLoading = false;
              }
            })
            .catch(() => {});
        } else {
          this.activeName = 'one';
        }
      });
    },
    // 获取组织架构
    async getOrgData() {
      const data = await getOrgData();
      this.orgTreeData = data || [];
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    },
    // 获取字典树
    async getDictData(code, dataType) {
      const data = await getDictData({ code });
      this[dataType] = data[0].nodes;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.el-form {
  height: 100%;

  .el-select,
  .el-cascader,
  .el-input {
    width: 100%;
  }
}

::v-deep .el-tabs {
  height: 100%;

  .el-tabs__content {
    height: calc(100% - 40px);

    .el-tab-pane {
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
